import React from 'react'
import PropTypes from 'prop-types'

const PATH_D = 'M6.25 6.875H13.75M6.25 9.375H10M1.875 10.6333C1.875 11.9667 2.81083 13.1283 4.13083 '
  + '13.3225C5.07167 13.4608 6.0225 13.5667 6.98333 13.6383C7.275 13.66 7.54167 13.8133 7.70417 '
  + '14.0558L10 17.5L12.2958 14.0558C12.3764 13.9361 12.4831 13.8362 12.608 13.7639C12.733 13.6915 '
  + '12.8727 13.6486 13.0167 13.6383C13.971 13.5671 14.9224 13.4617 15.8692 13.3225C17.1892 13.1283 '
  + '18.125 11.9675 18.125 10.6325V5.6175C18.125 4.2825 17.1892 3.12167 15.8692 2.9275C13.9258 '
  + '2.64226 11.9642 2.49938 10 2.5C8.00667 2.5 6.04667 2.64583 4.13083 2.9275C2.81083 3.12167 1.875 '
  + '4.28333 1.875 5.6175V10.6325V10.6333Z'

const CommentIcon = ({ className = '' }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    height="1em"
    viewBox="0 0 20 20"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d={PATH_D}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
)

CommentIcon.propTypes = {
  className: PropTypes.string
}

CommentIcon.defaultProps = {
  className: ''
}

export default CommentIcon
